import React from "react";


const CountCard = ({ title, amount, count }) => {
    return (
        <div className="border border-[#D2D2D2] bg-white w-full p-4  rounded-lg flex flex-col justify-between">

            <h2 className="md:text-base text-sm text-[#000000] font-semibold">
                {title} <span className="">({count})</span>
            </h2>
            <p className="text-[#000000] text-sm mt-2">(PKRD) {(amount).toFixed(4)}</p>
        </div>

    );
};

export default CountCard;
